import React from 'react'
import { IoIosArrowDropdown, IoIosArrowDropleft, IoIosArrowDropright } from 'react-icons/io';

/**
 * A component that renders a left/down arrow icon based on the given show state.
 * If show is false, the icon will be a left arrow. If show is true, the icon will be a down arrow.
 * The component can be clicked, and will call the given setShow function when clicked.
 * 
 * @param {boolean} show - The state of the icon. If false, the icon will be a left arrow. If true, the icon will be a down arrow.
 * @param {function} setShow - The function to call when the icon is clicked.
 */
export const LeftDownIcon = ({show, setShow}) => {
    const selectorToggle = () =>{
        setShow(!show)
    }
const icon = () => {
    const size = 25
    if(!show) return <IoIosArrowDropleft size={size}/>
    return <IoIosArrowDropdown size={size}/>
}
  return (
    <div>
      <div onClick={()=>selectorToggle()}>
      {icon()}
     </div>
    </div>
  )
}


/**
 * A component that renders a left/right arrow icon based on the given show state.
 * If show is false, the icon will be a right arrow. If show is true, the icon will be a left arrow.
 * The component can be clicked, and will call the given setShow function when clicked.
 * #core
 * @param {boolean} show - The state of the icon. If false, the icon will be a right arrow. If true, the icon will be a left arrow.
 * @param {function} setShow - The function to call when the icon is clicked.
 * @param {number} size - The size of the icon. Defaults to 25.
 */
export const LeftRightIcon = ({show, setShow, size = 25}) => {
    const selectorToggle = () =>{
        setShow(!show)
    }
const icon = () => {

    if(!show) return <IoIosArrowDropright size={size}/>
    return <IoIosArrowDropleft size={size}/>
}
  return (
    <div>
      <div onClick={()=>selectorToggle()}>
      {icon()}
     </div>
    </div>
  )
}

